<template>
    <div class="section6">
        <div class="swiper_area pc_swiper" v-if="firstin">
            <swiper ref="swiper6" :options="s6Options" @wheel.stop >
                <swiper-slide class="slide">
                    <img src="../../assets/zh/6-1/6_1_img1.jpg" alt="">
                </swiper-slide>
                <swiper-slide class="slide">
                    <img src="../../assets/zh/6-1/6_1_img2.jpg" alt="">
                </swiper-slide>
                <swiper-slide class="slide">
                    <img src="../../assets/zh/6-1/6_1_img3.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination s6_pagination"></div>
            <div class="swiper-button-prev s6_prev"></div>
            <div class="swiper-button-next s6_next"></div>
        </div>
        <div class="swiper_area wap_swiper" v-if="firstin">
            <swiper ref="swiper7" :options="s7Options" @wheel.stop >
                <swiper-slide class="slide">
                    <img src="../../assets/wap/zh/6-1/6_1_img1.jpg" alt="">
                </swiper-slide>
                <swiper-slide class="slide">
                    <img src="../../assets/wap/zh/6-1/6_1_img2.jpg" alt="">
                </swiper-slide>
                <swiper-slide class="slide">
                    <img src="../../assets/wap/zh/6-1/6_1_img3.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination s7_pagination"></div>
            <div class="swiper-button-prev s7_prev"></div>
            <div class="swiper-button-next s7_next"></div>
        </div>
    </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    props: ['language'],
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            firstin: false,
            s6Options: {
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                slidesPerView: 'auto',
                centeredSlides: true,
                slideToClickedSlide: true,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: "34.8",
                    depth: 200,
                    modifier: 2,
                    slideShadows: true
                },
                pagination: {
                    el: '.s6_pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.s6_next',
                    prevEl: '.s6_prev',
                },
            },
            s7Options: {
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                slidesPerView: 'auto',
                centeredSlides: true,
                slideToClickedSlide: true,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: "62.8",
                    depth: 200,
                    modifier: 2,
                    slideShadows: true
                },
                pagination: {
                    el: '.s7_pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.s7_next',
                    prevEl: '.s7_prev',
                },
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },

    methods: {
        onFirstVisit() {
            this.firstin = true
        },
        handleResize() {
            setTimeout(() => {
                if (this.$refs.swiper6 && this.$refs.swiper6.swiper) {
                    this.$refs.swiper6.swiper.update();
                    this.$refs.swiper6.swiper.updateSize();
                    this.$refs.swiper6.swiper.updateSlides();
                }
            },100)
        }
    }

}
</script>
<style lang="less" scoped>
.pc_swiper {
    display: block;
}
.wap_swiper {
    display: none;
}
.section6 {
    width: 100%;
    height: 100%;
    background: url(../../assets/zh/6-1/6_1bg.png) center center / cover no-repeat;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .swiper_area {
        margin: 1.5rem auto 0;
        width: 18.4rem;
        height: 8rem;
        position: relative;
    }

    .swiper-container {
        width: 16.2rem;
        height: 6.7rem;
    }

    .slide {
        width: 11.95rem;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
        }
    }

    ::v-deep .swiper-pagination {
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        height: .4rem;
        padding: 0 .5rem;
        background-color: rgba(153, 180, 255, 0.8);
        border-radius: 1rem;
        .swiper-pagination-bullet {
            opacity: 1;
            width: .5rem;
            height: .5rem;
            background: url(../../assets/zh/6-1/bullet.png) center .18rem / .16rem .16rem no-repeat;
            border-radius: unset;
            outline: none;

            &.swiper-pagination-bullet-active {
                background: url(../../assets/zh/6-1/bullet_active.png) center center / .57rem .57rem no-repeat;
            }

        }
    }

    .swiper-button-prev {
        top: 38%;
        width: 1.88rem;
        height: 1.3rem;
        background: url(../../assets/zh/5-1/5_1left.png) 0 0 / 100% 100% no-repeat;
        left: 0;
    }

    .swiper-button-next {
        top: 38%;
        width: 1.88rem;
        height: 1.3rem;;
        background: url(../../assets/zh/5-1/5_1right.png) 0 0 / 100% 100% no-repeat;
        right: 0;
    }
}

@media screen and (max-width: 751px) {
    .pc_swiper {
        display: none;
    }
    .wap_swiper {
        display: block;
    }
    .section6 {
        .swiper_area {
            width: 6.86rem;
            height: 8.37rem;
            margin: 1rem auto 0;
            .swiper-container {
                width: 100%;
                height: 100%;
                .slide {
                    width: 4.69rem;
                    img {
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }
        .swiper-button-prev {
            left: -0.4rem;
            top: 45%;
            -webkit-tap-highlight-color: transparent;
        }
        .swiper-button-next {
            right: -0.4rem;
            top: 45%;
            -webkit-tap-highlight-color: transparent;
        }
        .swiper-pagination {
            bottom: -1.2rem;
        }
    }
}

</style>